import styled from "styled-components";

export const ButtonRow = styled.div`
  display: flex;
  gap: 5px;
  margin: 1rem auto;
`;

export const BoxContainer = styled.div`
  color: black;
  padding: 2rem;

  svg {
    cursor: pointer;
  }
`;
